import React, { Suspense, lazy, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import AuthUser from "../front/Auth/AuthUser";
import { userRoles } from "./userRoles";
const Login = lazy(() => import("../front/Auth/Login"));
// Auth Pages

// CRM Pages

interface RoleObject {
  RoleId: number;
  Role: string;
}
interface Roles {
  RolesArray: Array<string>;
}
//const UserRoles: RoleObject[] = [
//    {
//        RoleId: 1, Role: "Master Admin"
//    },
//    {
//        RoleId: 2, Role: "Admin"
//    },
//    {
//        RoleId: 3, Role: "Project Manager"
//    },
//    {
//        RoleId: 4, Role: "Job Supervisor"
//    }

//];
const ProtectedRoutes = ({ RolesArray }: Roles) => {
  const { getloginInfo, user } = AuthUser();
  const IsAuthenticated =
    getloginInfo() == null ? false : getloginInfo().IsAuthenticated;
  const LoggedInUserType = user.userTypeID;
  const UserTypeName: RoleObject[] = userRoles.filter(
    (a) => a.RoleId == LoggedInUserType
  );
  const location = useLocation();
  let IsAllowedUser = false;
  if (UserTypeName.length > 0) {
    IsAllowedUser = RolesArray.includes(UserTypeName[0].Role);
  }
  useEffect(() => {
    let componentName = "";
    const path = location.pathname;
    switch (path) {
      case "/Dashboard":
        componentName = "Dashboard";
        break;
      case "/Customers":
        componentName = "Customers";
        break;
      case "/Contract":
        componentName = "Contracts";
        break;
      case "/SalesProfitReport":
        componentName = "Sales Profit Report";
        break;
      case "/Companies":
        componentName = "Companies";
        break;
      case "/PaymentSchedules":
        componentName = "Payment Schedules";
        break;
      case "/PaymentReceive":
        componentName = "Payment Receive";
        break;
      case "/Report/CustomerPaymentReport":
        componentName = "Customer Payment Report";
        break;
      case "/ContractorBill":
        componentName = "Contractor Bill";
        break;
      case "/SalesPersonCommission":
        componentName = "Sales Person Commission";
        break;
      case "/AccountPayable":
        componentName = "Account Payable";
        break;
      case "/Contractor":
        componentName = "Contractor";
        break;
      case "/Runners":
        componentName = "Runners";
        break;
      case "/SalesRep":
        componentName = "Sales Rep";
        break;
      case "/User":
        componentName = "User";
        break;
      case "/Vendors":
        componentName = "Store/Vendors";
        break;
      case "/ExpenseTypes":
        componentName = "Expense Types";
        break;
      case "/Admin/Dashboard":
        componentName = "Dashboard";
        break;
      case "/Admin/Clients":
        componentName = "Clients";
        break;
      case "/Admin/User":
        componentName = "User";
        break;
      case "/Admin/MenuSection":
        componentName = "MenuSection";
        break;
      case "/Admin/MenuLink":
        componentName = "MenuLink";
        break;
      case "/Admin/IPSecuritySetting":
        componentName = "IP Security Setting";
        break;
      case "/Admin/AdminUser":
        componentName = "Admin User";
        break;
      case "/Admin/ErrorLogReport":
        componentName = "Error Log Report";
        break;
      default:
        componentName = "";
        break;
    }
    // Update the document title based on the path
    document.title = `${componentName} - CRM`;
  }, [location]);
  return IsAuthenticated ? (
    RolesArray.length > 0 ? (
      IsAllowedUser == true ? (
        <Outlet />
      ) : (
        <Navigate to="/Unauthorized" />
      )
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

export default ProtectedRoutes;
